import React from "react";
import PropTypes from 'prop-types';
import CheckboxMUI from '@material-ui/core/Checkbox';
import { withStyles } from '@material-ui/core/styles';
import classnames from 'classnames';
import CheckBoxUncheckedIcon from "../../../utils/CheckBoxUncheckedIcon"
import CheckBoxChecked from '@material-ui/icons/CheckBox'

class Checkbox extends React.Component {
    render() {
        const {
            checked = false,
            onChange = () => { },
            isIndeterminate = false,
            className,
            classes,
            disabled
        } = this.props;

        let borderColor = disabled ? "rgba(0, 0, 0, 0.09)" : "rgba(181, 180, 180, 1)";
        return (
            <CheckboxMUI
                checked={checked}
                onChange={onChange}
                icon={<CheckBoxUncheckedIcon stroke={borderColor}/>}
                checkedIcon={<CheckBoxChecked viewBox="0 0 24 24" />}
                onClick={e => e.stopPropagation()}
                color="default"
                disabled={disabled}
                className={classnames(className, classes.root)}
                indeterminate={isIndeterminate}
            />
        )
    }
}

Checkbox.propTypes = {
    checked: PropTypes.bool,
    className: PropTypes.string,
    onChange: PropTypes.func.isRequired,
    ref: PropTypes.func
};

const styles = {
    root: {
        padding: 0,
    },
};

export default withStyles(styles)(Checkbox);